import React, { useContext } from "react";
import styled from "styled-components";
import { AppContext } from "./AppProvider";

const ViewBoxStyles = styled.div``;

function Header() {
  const ctx = useContext(AppContext);
  return (
    <ViewBoxStyles>
      <p style={{ marginTop: "0" }}>View-box:</p>
      <div style={{ display: "flex" }}>
        {/* <label>Min-X: </label> */}
        <input
          type="number"
          name="minX"
          min="1"
          max="1000"
          onChange={(e) => ctx.minXChangeHandler(e.target.value)}
          value={ctx.minX}
        ></input>{" "}
        {/* <label>Min-Y: </label> */}
        <input
          type="number"
          name="minY"
          min="1"
          max="1000"
          onChange={(e) => ctx.minYChangeHandler(e.target.value)}
          value={ctx.minY}
        ></input>{" "}
        {/* <label>Width: </label> */}
        <input
          type="number"
          name="width"
          min="1"
          max="1000"
          onChange={(e) => ctx.widthChangeHandler(e.target.value)}
          value={ctx.width}
        ></input>{" "}
        {/* <label>Height: </label> */}
        <input
          type="number"
          name="height"
          min="1"
          max="1000"
          onChange={(e) => ctx.heightChangeHandler(e.target.value)}
          value={ctx.height}
        ></input>
      </div>
    </ViewBoxStyles>
  );
}

export default Header;
